import { FaxTagColor, IFaxMessage, IFaxTag } from '@dataTypes/fax.type'

/** Placeholder labels shown in the Fax sidebar and on labeled rows. */
export const MOCK_FAX_TAGS: IFaxTag[] = [
  {
    fax_tag_id: 'mock-fax-tag-1',
    clinic_id: 'mock-clinic',
    tag_name: 'Insurance',
    color: FaxTagColor.Blue,
  },
  {
    fax_tag_id: 'mock-fax-tag-2',
    clinic_id: 'mock-clinic',
    tag_name: 'Referral',
    color: FaxTagColor.Orange,
  },
  {
    fax_tag_id: 'mock-fax-tag-3',
    clinic_id: 'mock-clinic',
    tag_name: 'Urgent',
    color: FaxTagColor.Red,
  },
]

/**
 * Placeholder fax rows for Message Center until the fax API is available.
 * Rows without a matching contact show the "Add to contacts" link (see Figma
 * https://www.figma.com/design/HpghvAHzvqkSSHZmExDkZw/ENAMELAI-CRM-2.0?node-id=28088-15772).
 */
export const MOCK_FAX_MESSAGES: IFaxMessage[] = [
  {
    fax_message_id: 'mock-fax-1',
    clinic_id: 'mock-clinic',
    direction: 'Incoming',
    from_number: '3852663328',
    to_number: '9495559000',
    status: 'received',
    subject: '[Mock] Unknown sender fax',
    cover_note: 'Please review the attached documents.',
    page_count: 3,
    is_read: false,
    is_archived: false,
    is_hidden: false,
    contact_id: null,
    contact: null,
    fax_tag_id: MOCK_FAX_TAGS[2].fax_tag_id,
    fax_tag: MOCK_FAX_TAGS[2],
    date_time_created_at: '2026-07-17T16:32:00Z',
    system_view: 'inbox',
  },
  {
    fax_message_id: 'mock-fax-2',
    clinic_id: 'mock-clinic',
    direction: 'Incoming',
    from_number: '8015554477',
    to_number: '9495559000',
    status: 'received',
    subject: '[Mock] Insurance pre-auth request',
    cover_note: 'Delta Dental pre-authorization packet for crown #14.',
    page_count: 5,
    is_read: true,
    is_archived: false,
    is_hidden: false,
    contact_id: null,
    contact: null,
    fax_tag_id: MOCK_FAX_TAGS[0].fax_tag_id,
    fax_tag: MOCK_FAX_TAGS[0],
    date_time_created_at: '2026-07-15T10:05:00Z',
    system_view: 'inbox',
  },
  {
    fax_message_id: 'mock-fax-3',
    clinic_id: 'mock-clinic',
    direction: 'Incoming',
    from_number: '5625553003',
    to_number: '9495559000',
    status: 'received',
    subject: '[Mock] Lab case update — Marcus Nguyen',
    cover_note: 'Crown try-in scheduled; please confirm shade selection.',
    page_count: 2,
    is_read: true,
    is_archived: false,
    is_hidden: false,
    contact_id: 'mock-contact-3',
    contact: {
      contact_id: 'mock-contact-3',
      first_name: 'Marcus',
      last_name: 'Nguyen',
      cellphone: '7145550303',
      fax_number: '5625553003',
      email: 'marcus.nguyen@example.com',
    },
    date_time_created_at: '2026-07-14T18:45:00Z',
    system_view: 'inbox',
  },
]

export const MOCK_FAX_COUNTS: Record<string, number> = {
  inbox: MOCK_FAX_MESSAGES.length,
  sent: 0,
  draft: 0,
  archive: 0,
  trash: 0,
  history: 0,
  blocked: 0,
}
